<template>
    <div>
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto">
                <form class="form-inline my-2 my-lg-0">
                    <multiselect
                        v-model="search.employee"
                        class="form-control border-0"
                        :options="employeeAll"
                        select-label=""
                        selectedLabel=""
                        deselectLabel=""
                        placeholder="เลือกพนักงาน"
                        :customLabel="employeeLabel"
                        track-by="id">
                    </multiselect>

                    <date-picker
                        v-model="search.date"
                        type="date"
                        :lang="lang"
                        :format="changeFormat"
                        placeholder="วันที่">
                    </date-picker>
                    &nbsp;&nbsp;
                    <button class="btn btn-success my-2 my-sm-0"
                            @click="searchShopping"
                            type="button">
                        <icon name="search"></icon>
                        ค้นหา
                    </button>
                    &nbsp;
                    <router-link to="shopping-form">
                        <button class="btn btn-warning my-2 my-sm-0"
                                type="button">
                            <icon name="plus"></icon>
                            บันทึกค่าใช้จ่าย
                        </button>
                    </router-link>
                    &nbsp;
                </form>
            </div>
        </nav>
        <div class="col-12 table-responsive">
            <table style="text-align: center" class="table table-bordered">
                <thead>
                <tr>
                    <th scope="col">ลำดับ</th>
                    <th scope="col">รหัสพนักงาน</th>
                    <th scope="col">ชื่อพนักงาน</th>
                    <th scope="col">ยอดเงิน</th>
                    <th scope="col">สถานะ</th>
                    <th scope="col">วันที่บันทึก</th>
                    <th scope="col">ผู้บันทึก</th>
                    <th scope="col">แก้ไข / ลบ</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(data,index) in shoppingList">
                    <td>{{ ((dataPaginate.current_page - 1) * 10) + (index + 1) }}</td>
                    <td>{{ data.employee_details ? data.employee_details.employee_no : '' }}</td>
                    <td>{{ data.employee_details ? data.employee_details.name : '' }}</td>
                    <td>{{ data.amount | currency }}</td>
                    <td>
                        <template v-if="data.status_paid == 0">
                            <span style="color: red">ยังไม่ได้ชำระ</span>
                        </template>
                        <template v-else>
                            <span style="color: green">ชำระเสร็จสิ้น</span>
                        </template>
                    </td>
                    <td>{{ data.date  | moment("DD/MM/YYYY") }}</td>
                    <td>{{ data.recorder }}</td>
                    <td>
                        <a @click="showEditModal(data.id)">
                            <icon name="pencil-alt"></icon>
                        </a>
                        &nbsp;&nbsp;
                        <a @click="showDeleteModal(data.id)">
                            <icon name="trash"></icon>
                        </a>
                    </td>

                </tr>
                </tbody>
            </table>
        </div>

        <div v-if="shoppingList.length > 0">
            <vue-pagination :pagination="dataPaginate"
                            @paginate="getShoppingList">
            </vue-pagination>
        </div>
        <br>

        <b-modal size="lg" hide-header hide-footer ref="edit_shopping">
            <shopping-modal @submit="saveShopping"></shopping-modal>
        </b-modal>

        <!--delete modal-->
        <b-modal hide-header hide-footer ref="delete_data">
            <div style="text-align: center;">
                <h4>คุณต้องการลบข้อมูลใช่ไหม?</h4>
                <br/>
                <button @click="deleteShopping"
                        type="button"
                        class="btn btn-success">
                    ตกลง
                </button>
                &nbsp;&nbsp;
                <button @click="hideDeleteModal"
                        type="button"
                        class="btn btn-outline-secondary">
                    ยกเลิก
                </button>
            </div>
        </b-modal>
        <b-modal hide-footer hide-header ref="loading">
            <div>
                <loading @submit="hideLoadingModal" :msg="msg" :status="loading_status"></loading>
            </div>
        </b-modal>
    </div>
</template>

<script>
import ShoppingModal from "./Modal/ShoppingModal";
import {mapState} from "vuex"
import Multiselect from "vue-multiselect"
import VuePagination from "../../../Pagination";
import moment from "moment";
import DatePicker from 'vue2-datepicker'
import Loading from "@/components/Utility/Loading.vue";

export default {
    components: {
        Loading,
        ShoppingModal,
        Multiselect,
        VuePagination,
        DatePicker
    },
    name: "shopping-list",
    created() {
        this.$store.dispatch("ShoppingEmployee/setShoppingEmployee");
        this.getCurrentDate();
        this.$store.dispatch('ShoppingEmployee/clearFormData');
        this.$store.dispatch('ShoppingEmployee/clearSearch');
        this.$store.dispatch("Employee/getEmployeeAll").then(res => {
            this.employeeAll = res;
        });
    },
    data() {
        return {
            id: null,
            event_submit: false,
            currentDate: "",
            employeeAll: [],
            loading_status: '',
            msg: '',
            changeFormat: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment) + 543;
                    //console.log(moment(date).format('DD/MM/'+year));
                    return date ? moment(date).format('DD/MM/' + year) : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
        };
    },
    computed: {
        ...mapState({
            shoppingList: state => {
                return state.ShoppingEmployee.shoppingEmployeeList;
            },
            dataPaginate: state => {
                return state.ShoppingEmployee.dataPaginate;
            },
            search: state => {
                return state.ShoppingEmployee.search;
            },
        }),
    },
    methods: {
        employeeLabel(option) {
            return `${option.employee_no} - ${option.name}`
        },
        showDeleteModal(id) {
            this.id = id;
            this.$refs.delete_data.show();
        },
        hideDeleteModal() {
            this.$refs.delete_data.hide();
        },
        showEditModal(id) {
            this.id = id;
            this.$store.dispatch("ShoppingEmployee/showShoppingEmployeeByID", id).then(() => {
                this.$refs.edit_shopping.show();
            })
        },
        hideEditModal() {
            this.$refs.edit_shopping.hide();
        },
        deleteShopping() {
            this.$store.dispatch("ShoppingEmployee/delete", this.id).then(() => {
                this.$store.dispatch("ShoppingEmployee/setShoppingEmployee");
                this.hideDeleteModal()
            });

        },
        getCurrentDate() {
            this.currentDate = moment().format("YYYY-MM-DD");
        },
        showLoadingModal() {
            this.$refs.loading.show();
        },
        hideLoadingModal() {
            this.$refs.loading.hide();
        },
        searchShopping() {
            this.event_submit = true;
            this.showLoadingModal();
            this.loading_status = 1;
            this.msg = 'กรุณารอสักครู่';
            if (this.search.date) {
                this.search.date = moment(this.search.date).format("YYYY-MM-DD")
            } else {
                this.search.date = ""
            }

            if (this.search.employee) {
                this.search.employee_id = this.search.employee.id
            } else {
                this.search.employee_id = ""
            }
            this.$store.dispatch("ShoppingEmployee/search", this.search).then(() => this.hideLoadingModal())
        },
        getShoppingList() {
            const page = this.dataPaginate.current_page;
            this.showLoadingModal();
            this.loading_status = 1;
            this.msg = 'กรุณารอสักครู่';
            //paginate search
            if (this.event_submit) {
                //change date format
                if (this.search.date) {
                    this.search.date = moment(this.search.date).format("YYYY-MM-DD")
                } else {
                    this.search.date = ""
                }
                if (this.search.employee) {
                    this.search.employee_id = this.search.employee.id
                } else {
                    this.search.employee_id = ""
                }
                let data = {
                    page: page,
                    employee_id: this.search.employee_id,
                    date: this.search.date
                };
                this.$store.dispatch('ShoppingEmployee/search', data).then(() => this.hideLoadingModal())
            }
            //paginate get data
            else {
                this.$store.dispatch('ShoppingEmployee/setShoppingEmployee', page).then(() => this.hideLoadingModal())
            }

        },
        saveShopping(submitData) {
            if (submitData == 0) {
                //console.log('list');
                this.$store.dispatch('ShoppingEmployee/clearFormData')
            } else {
                this.$store.dispatch('ShoppingEmployee/saveShoppingEmployee', {
                    id: submitData.id,
                    data: submitData
                }).then(() => {
                    this.$store.dispatch("ShoppingEmployee/setShoppingEmployee");
                })
                this.$store.dispatch('ShoppingEmployee/clearFormData')
            }
            this.hideEditModal();
        },
    }
}
</script>

<style scoped>

</style>
